module.exports = __webpack_public_path__ + "static/media/email-in.7c1b9932.svg";